import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Headline from "../Headline/component";
import { Label } from "../../../Label/component";
import LinkWrap from "../../../LinkWrap/component";
import Metadata from "../Metadata/component";
import { normalizeClass } from "../../../../utils/path/library";
import classNames from "classnames";

/**
 * Text only Card component.
 */
const CardText = ({
    className,
    focus,
    flag,
    sourceId,
    external,
    url,
    cardClickHandler,
    flagId,
    metadataId,
    updateTime,
    subSection,
    baseSection,
    departments,
    displayComments,
    headlineId,
    title,
}) => {
    const domNode = useRef(null);

    useEffect(() => {
        if (focus !== undefined) {
            domNode.current.focus();
        }
    }, []);

    const flagClassName = normalizeClass("flag", flag);
    const classes = classNames("card", "cardText", flagClassName, className);

    const linkProps = {
        "data-contentid": sourceId,
        id: sourceId,
        external: external,
        url: url,
        onClick: cardClickHandler,
    };

    const labelProps = {
        flag: flag,
        external: external,
        id: flagId,
    };

    const metaProps = {
        baseSection: baseSection,
        subSection: subSection,
        updated: updateTime,
        showTimestamp: true,
        departments: departments,
        id: metadataId,
        url: url,
        displayComments: displayComments,
    };

    return (
        <LinkWrap
            className={classes}
            {...linkProps}
            data-testid="card-text"
            ref={domNode}
        >
            <div className="card-content">
                <div className="card-content-top">
                    <Label {...labelProps} />
                    <Headline id={headlineId} text={title} />
                </div>
                <div className="card-content-bottom">
                    <Metadata {...metaProps} />
                </div>
            </div>
        </LinkWrap>
    );
};
CardText.propTypes = {
    // REQUIRED
    external: PropTypes.bool.isRequired,
    // OPTIONAL
    className: PropTypes.string,
    itemType: PropTypes.string,
};

export default CardText;
